import request from 'config/axios'

export const getFinancialSituation = () => request.get('/gringott/customers/patrimonialsituation')

export const updateFinancialSituation = ({ eletronicSignature, ...payload }) => {
  const data = { ...payload, electronicSignature: eletronicSignature }
  return request.put('/registrar/v1/customers/patrimonialsituation', data)
}
